import {ref, computed} from "vue";
import {useStore} from "vuex";
import {useVuelidate} from "@vuelidate/core";
import {required, email, minLength} from "@/utils/i18n-validators";

export function useUsers() {
    const store = useStore();
    const user = computed(() => store.getters.getCurrentUser);
    const isUpdated = ref(false);

    const form = ref({
        first_name: '',
        last_name: '',
        patronymic: '',
        roles: [],
        email: '',
        phone: '',
        language: 'ru'
    });
    const rules = computed(() => {
        return {
            first_name: {required},
            last_name: {required},
            email: form.value.email ? {email} : {},
            phone: {required, minLength: minLength(10)},
            language: {required},
        }
    });

    const v$ = useVuelidate(rules, form);

    const updateUser = async ({id, data}) => {
        const result = await v$.value.$validate();
        if (!result) {
            return;
        }
        await store.dispatch('fetchSaveUserData', {id, data});
        isUpdated.value = true;
    };

    const loadDocs = async (id, page) => {
        await store.dispatch('fetchDocsUser', {id, page});
    }

    const loadRooms = async (id, page) => {
        await store.dispatch('fetchRoomsUser', {id, page});
    }

    const loadUser = async (id) => {
        await store.dispatch('fetchUser', id);
        await loadDocs(id, 1);
        await loadRooms(id, 1);
    };

    return {user, loadUser, loadRooms, loadDocs, updateUser, form, v$, isUpdated};
}

